export default {
  menu_items: []
}
